var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.34752 7.41669H5.14569C4.32195 7.41669 3.68305 8.13604 3.78031 8.95403L5.02727 19.4416C5.0821 19.9027 5.47312 20.25 5.93752 20.25H19.8562C20.3282 20.25 20.7231 19.8916 20.7686 19.4217L21.7849 8.92419C21.8631 8.1162 21.228 7.41669 20.4163 7.41669H19.1809",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.05566 11.0833H21.4723",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.65625 15.6423H16.9063",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7643 3.75C10.7393 3.75 9.09766 6.92382 9.09766 10.8389C9.09766 10.9207 9.09839 11.0022 9.09981 11.0833H16.4288C16.4303 11.0022 16.431 10.9207 16.431 10.8389C16.431 6.92382 14.7894 3.75 12.7643 3.75Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg);
export default __webpack_public_path__ + "static/media/商品管理.803c64121f0ad54916e8914a28bf3f4c.svg";
export { ForwardRef as ReactComponent };